import axios from 'axios';
import { PREFIX_URL } from './config';

const URLS = {}

URLS.BASE_URL = `${PREFIX_URL}/document`;
URLS.V1_BASE_URL = `${PREFIX_URL}/v01/document`;
URLS.FILES = `${URLS.V1_BASE_URL}/folder`;

// URLS.UPLOAD_DOCUMENT = `${URLS.PREFIX_URL}/files`; revert back until all BE updated for the new file updates.
URLS.UPLOAD_DOCUMENT = `${URLS.BASE_URL}/upload`;
URLS.RENAME = `${URLS.BASE_URL}/rename`;
URLS.READ = `${URLS.BASE_URL}/read`;
URLS.TAG_WORKSTREAM = `${URLS.BASE_URL}/tagWorkstream`;
URLS.FAVORITE = `${PREFIX_URL}/v01/starred`;
URLS.FILE_MEMBERS = `${URLS.BASE_URL}/getFileMembers`;
URLS.MOVE = `${URLS.BASE_URL}/bulkUpdate`;


export const fetchActiveFolders = async (projectId, userId, userType, folderId = null) => {
    const params = {
        linkId: projectId,
        linkType: "project",
        userId: userId,
        userType: userType,
        starredUser: userId,
        isActive: 1,
        isDeleted: 0,
        isArchived: 0,
        folderId: folderId,
        type: "folder"
    }

    return await axios.get(URLS.BASE_URL, { params })
        .then(res => res.data);
}

export const fetchDocuments = async (params) => {
    return await axios.get(URLS.FILES, { params })
        .then(res => res.data);
}

export const uploadDocument = async (cancelToken, formDataFile, handleUploadProgress) => {
    return await axios.post(URLS.UPLOAD_DOCUMENT, formDataFile, {
        cancelToken: cancelToken.token,
        onUploadProgress: handleUploadProgress
    }).catch(error => {
        if (!axios.isCancel(error)) {
            return Promise.reject();
        }
    });
}

export const saveDocument = async (cancelToken, file, projectId, userId, folderId = null) => {
    const params = {
        DocumentToSave: [{
            name: file.filename,
            origin: file.origin,
            project: projectId,
            status: "new",
            type: "document",
            uploadedBy: userId,
            ...(folderId && { folderId })
        }],
        projectId: projectId,
        usersId: userId,
        tagWorkstream: file.tagWorkstream
    }

    return await axios.post(URLS.BASE_URL, params, {
        cancelToken: cancelToken.token,
    }).catch(error => {
        if (!axios.isCancel(error)) {
            return Promise.reject();
        }
    });

}
export const rename = async (params, documentId, userId) => {
    const url = `${URLS.RENAME}/${documentId}?starredUser=${userId}`;

    return await axios.put(url, params)
        .catch(error => {
            console.error(error);
        });
}

export const favorite = async (params) => {
    return await axios.post(URLS.FAVORITE, params)
        .catch(error => {
            console.error(error);
        });
}

export const read = async (params) => {
    return await axios.post(URLS.READ, params)
        .catch(error => {
            console.error(error);
        });
}

export const removeRead = async (params) => {
    const url = `${URLS.READ}/${params.documentId}`;

    return await axios.delete(url, params)
        .catch(error => {
            console.error(error);
        });
}

export const tagWorkstream = async (params) => {
    const url = `${URLS.TAG_WORKSTREAM}/${params.projectId}`;

    return await axios.put(url, params)
        .catch(error => {
            console.error(error);
        });
}

export const move = async (destinationId, params) => {
    const url = `${URLS.MOVE}/${destinationId}`;

    return await axios.put(url, params)
        .catch(error => {
            console.error(error);
        });
}

